"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnnouncedMessage = exports.default = void 0;
var _react = require("react");
const ANNOUNCE_DELAY = 50;
const RESET_DELAY_DEFAULT = 1000;
const useAnnouncedMessage = ({
  announce,
  message,
  onMessageAnnounced,
  resetDelay = RESET_DELAY_DEFAULT,
  disableReset = false
}, dependencies = []) => {
  const [announcedMessage, setAnnouncedMessage] = (0, _react.useState)(message);
  let setChildrenTimer;
  let resetTimer;
  (0, _react.useEffect)(() => {
    if (announce) {
      clearTimeout(setChildrenTimer);
      clearTimeout(resetTimer);
      setAnnouncedMessage('');
      // set timer to render message in order for JAWS to pick up
      // the span's update on initial load
      setChildrenTimer = setTimeout(() => {
        setAnnouncedMessage(message);
      }, ANNOUNCE_DELAY);
      if (!disableReset) {
        // set timer to reset message state and call consumer callback
        resetTimer = setTimeout(() => {
          setAnnouncedMessage('');
          onMessageAnnounced === null || onMessageAnnounced === void 0 ? void 0 : onMessageAnnounced();
        }, resetDelay);
      }
    }
    return () => {
      clearTimeout(setChildrenTimer);
      clearTimeout(resetTimer);
    };
  }, [announce, ...dependencies]);
  (0, _react.useEffect)(() => {
    if (!announce) {
      setAnnouncedMessage(message);
    }
  }, [message, ...dependencies]);
  return announcedMessage;
};
exports.useAnnouncedMessage = useAnnouncedMessage;
var _default = exports.default = useAnnouncedMessage;